import { useEffect, FC } from 'react';
import { ReleaseEnvironmentPageView } from './ReleaseEnvironmentPageView';
import { useListStore } from './hooks';

export const ReleaseEmvironmentPage: FC = () => {
  const { fetchReleaseEnvironments } = useListStore();

  useEffect(() => {
    void fetchReleaseEnvironments();
  }, [fetchReleaseEnvironments]);

  return <ReleaseEnvironmentPageView />;
};
